import type { WidgetConfig } from "./types.js";

export async function fetchConfig(apiBase: string, appKey: string): Promise<WidgetConfig> {
  const res = await fetch(`${apiBase}/v1/config?key=${encodeURIComponent(appKey)}`, {
    method: "GET",
    headers: { "X-Widget-Key": appKey },
  });
  if (!res.ok) throw new Error(`config ${res.status}`);
  return (await res.json()) as WidgetConfig;
}

export async function submitReport(
  apiBase: string,
  appKey: string,
  payload: Record<string, unknown>,
): Promise<{ id: string }> {
  const res = await fetch(`${apiBase}/v1/report`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Widget-Key": appKey,
    },
    body: JSON.stringify(payload),
  });
  if (!res.ok) {
    const text = await res.text().catch(() => "");
    throw new Error(`${res.status}: ${text || res.statusText}`);
  }
  return (await res.json()) as { id: string };
}
